<label class="toggle-field">
  <input
    type="checkbox"
    [checked]="checked"
    [disabled]="disabled"
    (change)="onToggle($event)"
  />
  <span class="slider"></span>
</label>
